// import Settings from './Settings';

export default {
  priority: 10,
  exact: true,
  path: 'settings',
  permissions: [],
  // component: Settings,
  component: load(() => import(/* webpackChunkName: "Settings" */ './Settings')),
  name: app.translate('routes.home.settings.Settings'),
  icon: 'settings',
  drawer: false,
};
